module.exports = __webpack_public_path__ + "img/businessman.93a57c9f.png";